export const actionType = {
    REDIRECT: 'REDIRECT'
} as const;
